export const approvePayoutV2 = {
    approvePayoutV2: 'Approve Payout V2',
    approvePayout: 'Approve Payout',
    username: 'Username',
    paymentName: 'PaymentName',
    refCode1: 'Ref Code 1',
    status: 'Status',
    transactionId: 'Transaction ID',
    refCode3: 'Ref Code 3',
    createdAt: 'Created At',
    advanceFilter: 'Advance Filter',
    approve: 'Approve',
    reject: 'Reject',
    amount: 'Amount',
    remark: 'Remark',
    date: 'Date',
    depositDate: 'Deposit Date',
    accountId: 'AccountId',
    txnRemark: 'TxnRemark',
    rejectPayoutTitle: 'Reject Payout',
    approvePayoutTitle: 'Approve Payout',
    note: 'Note',
    userCode: 'Phone number',
    bankAccountName: "Bank Account Name",
    bankAccountNumber: "Bank Account Number",
    confirmPayout: "Confirm Payout",
}
